/* Pasión de Grada: botón "+ Añadir" de las sugerencias del carrito.
   Vive en un archivo global porque el bloque de sugerencias llega al cajón por "section rendering"
   (innerHTML) y los <script> insertados así no se ejecutan: con el carrito vacío al cargar la página, la función no existía. */
window.pgUpsellAdd = async function (btn) {
  var card = btn.closest('[data-pg-up]'); if (!card) return;
  var id = parseInt(card.querySelector('select').value, 10); if (!id) return;
  btn.disabled = true;
  try {
    var drawer = document.querySelector('cart-drawer');
    var r = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    });
    var state = await r.json();
    if (state.status) { btn.disabled = false; return; }
    if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(state); else window.location.reload();
  } catch (e) { btn.disabled = false; }
};
